// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AiFormAepFragmentDoc } from '../../../../../components/formFields/ai/utils/aiProposalForm.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TakeoffsAiReviewBannerQueryVariables = Types.Exact<{
  planPackageId: Types.Scalars['ID']['input'];
}>;


export type TakeoffsAiReviewBannerQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, entityProposals: Array<{ __typename?: 'AiEntityProposal', id: string, rationalization?: string | null | undefined, type: { __typename?: 'AiEntityProposalTypeDetail', code: Types.AiEntityProposalType }, entity:
          | { __typename: 'MaterialListing', id: string }
          | { __typename: 'MaterialVariant', id: string }
          | { __typename: 'ReadyPlanLocation', id: string }
          | { __typename: 'ReadyPlanOption', id: string }
          | { __typename: 'ReadyPlanProgramData', id: string }
          | { __typename: 'TakeoffLineItem', id: string }
        , fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, parentType: Types.AiEntityProposalType, pageNumbers?: Array<number> | null | undefined, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }> }> } | null | undefined } };

export type TakeoffsAiReviewBanner_ResolveProposalsMutationVariables = Types.Exact<{
  input: Array<Types.ResolveAiFieldProposalInput> | Types.ResolveAiFieldProposalInput;
}>;


export type TakeoffsAiReviewBanner_ResolveProposalsMutation = { __typename?: 'Mutation', resolveAiFieldProposals: { __typename?: 'ResolveAiFieldProposalsResult', aiFieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }> } };


export const TakeoffsAiReviewBannerDocument = gql`
    query TakeoffsAiReviewBanner($planPackageId: ID!) {
  planPackage(id: $planPackageId) {
    id
    aiProposal {
      id
      entityProposals(entityType: [TAKEOFF_LINE_ITEM]) {
        ...AiFormAep
      }
    }
  }
}
    ${AiFormAepFragmentDoc}`;

/**
 * __useTakeoffsAiReviewBannerQuery__
 *
 * To run a query within a React component, call `useTakeoffsAiReviewBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTakeoffsAiReviewBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTakeoffsAiReviewBannerQuery({
 *   variables: {
 *      planPackageId: // value for 'planPackageId'
 *   },
 * });
 */
export function useTakeoffsAiReviewBannerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TakeoffsAiReviewBannerQuery, TakeoffsAiReviewBannerQueryVariables> & ({ variables: TakeoffsAiReviewBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TakeoffsAiReviewBannerQuery, TakeoffsAiReviewBannerQueryVariables>(TakeoffsAiReviewBannerDocument, options);
      }
export function useTakeoffsAiReviewBannerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TakeoffsAiReviewBannerQuery, TakeoffsAiReviewBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TakeoffsAiReviewBannerQuery, TakeoffsAiReviewBannerQueryVariables>(TakeoffsAiReviewBannerDocument, options);
        }
// @ts-ignore
export function useTakeoffsAiReviewBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TakeoffsAiReviewBannerQuery, TakeoffsAiReviewBannerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TakeoffsAiReviewBannerQuery, TakeoffsAiReviewBannerQueryVariables>;
export function useTakeoffsAiReviewBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TakeoffsAiReviewBannerQuery, TakeoffsAiReviewBannerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TakeoffsAiReviewBannerQuery | undefined, TakeoffsAiReviewBannerQueryVariables>;
export function useTakeoffsAiReviewBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TakeoffsAiReviewBannerQuery, TakeoffsAiReviewBannerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TakeoffsAiReviewBannerQuery, TakeoffsAiReviewBannerQueryVariables>(TakeoffsAiReviewBannerDocument, options);
        }
export type TakeoffsAiReviewBannerQueryHookResult = ReturnType<typeof useTakeoffsAiReviewBannerQuery>;
export type TakeoffsAiReviewBannerLazyQueryHookResult = ReturnType<typeof useTakeoffsAiReviewBannerLazyQuery>;
export type TakeoffsAiReviewBannerSuspenseQueryHookResult = ReturnType<typeof useTakeoffsAiReviewBannerSuspenseQuery>;
export type TakeoffsAiReviewBannerQueryResult = ApolloReactCommon.QueryResult<TakeoffsAiReviewBannerQuery, TakeoffsAiReviewBannerQueryVariables>;
export const TakeoffsAiReviewBanner_ResolveProposalsDocument = gql`
    mutation TakeoffsAiReviewBanner_ResolveProposals($input: [ResolveAiFieldProposalInput!]!) {
  resolveAiFieldProposals(input: $input) {
    aiFieldProposals {
      id
      status {
        code
      }
    }
  }
}
    `;

/**
 * __useTakeoffsAiReviewBanner_ResolveProposalsMutation__
 *
 * To run a mutation, you first call `useTakeoffsAiReviewBanner_ResolveProposalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTakeoffsAiReviewBanner_ResolveProposalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [takeoffsAiReviewBannerResolveProposalsMutation, { data, loading, error }] = useTakeoffsAiReviewBanner_ResolveProposalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTakeoffsAiReviewBanner_ResolveProposalsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TakeoffsAiReviewBanner_ResolveProposalsMutation, TakeoffsAiReviewBanner_ResolveProposalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TakeoffsAiReviewBanner_ResolveProposalsMutation, TakeoffsAiReviewBanner_ResolveProposalsMutationVariables>(TakeoffsAiReviewBanner_ResolveProposalsDocument, options);
      }
export type TakeoffsAiReviewBanner_ResolveProposalsMutationHookResult = ReturnType<typeof useTakeoffsAiReviewBanner_ResolveProposalsMutation>;
export type TakeoffsAiReviewBanner_ResolveProposalsMutationResult = ApolloReactCommon.MutationResult<TakeoffsAiReviewBanner_ResolveProposalsMutation>;